module.exports = __webpack_public_path__ + "media/images/pt/relationships-segment-9e18a6616727bcc4454e78b5a380d407.jpg";